import { Injectable } from '@angular/core';
import { auth } from 'firebase/app';
import { AuthService } from "../../shared/services/auth.service";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { throwError, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Item { 
  id: string,
  title: string; 
  start: string;
  end: string;}

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private itemsCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  date: any;
  constructor(
    private afs: AngularFirestore,
    public authService: AuthService,
    ) {
    this.itemsCollection = afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid + '/events');
    this.items = this.itemsCollection.valueChanges();
    
   }

   dateDetails(dateDetails){
     console.log(dateDetails);
   }

   eventDetails(eventDetails){
      console.log(eventDetails);
   }

   // ADD EVENT
   addEvent(event) {
    console.log("Date Service clicked");
    this.itemsCollection.add({
      id: this.afs.createId(),
      title: "Event Title", 
      start: event.dateStr,
      end: "",
    });
  }

  //ADD event via Form
  addFormEvent(title, start, end, desc) {
    console.log("Event Service clicked");
    console.log(event);
    this.afs.collection("users/" + this.authService.afAuth.auth.currentUser.uid + "/events").add({
      title: title,
      start: start,
      end: end,
      description: desc
    });
    }
  }

